import { render, staticRenderFns } from "./TransactionsAdvanced.vue?vue&type=template&id=0008f6b0"
import script from "./TransactionsAdvanced.vue?vue&type=script&lang=js"
export * from "./TransactionsAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports